module.exports = __webpack_public_path__ + "static/media/grosfarceur.346cc7d5.gif";